<template>
  <div class="info-container normal-font">
    <div class="row justify-end">
      <q-btn
          round
          dense
          flat
          icon="close"
          color="primary"
          @click="router.back()"
      />
    </div>
    <h5>Imprint & Privacy Policy</h5>

    <h5>Imprint</h5>
    <p>
      Responsible for the content of this website:<br>
      <strong>Philip Spahn</strong><br>
      Alt-Heddernheim 43<br>
      60439 Frankfurt am Main<br>
      Germany
    </p>
    <p>
      Phone: 0176 30734651<br>
      Email: <a href="mailto:philip20794@gmail.com">philip20794@gmail.com</a>
    </p>

    <h5>Privacy Policy</h5>
    <h5>1. Privacy at a Glance</h5>
    <h5>General Information</h5>
    <p>
      The following notes provide a simple overview of what happens to your personal data when you visit this website. Personal data is any
      data that can be used to personally identify you. Detailed information on the topic of data protection can be found in our privacy
      policy listed below this text.
    </p>
    <h5>Data Collection on This Website</h5>
    <h5>Who is responsible for data collection on this website?</h5>
    <p>
      Data processing on this website is carried out by the website operator. You can find their contact details in the section "Notice to the
      Responsible Party" in this privacy policy.
    </p>
    <h5>How do we collect your data?</h5>
    <p>Some of your data is collected when you provide it to us, for example, data you enter into a contact form.</p>
    <p>
      Other data is collected automatically or with your consent when you visit the website by our IT systems. These are mainly technical data
      (e.g., internet browser, operating system, or time of page access). This data is collected automatically as soon as you enter our
      website.
    </p>
    <h5>What do we use your data for?</h5>
    <p>
      Some of the data is collected to ensure the website is displayed correctly. Other data may be used to analyze your user behavior. If
      contracts are entered into or initiated through the website, the transmitted data is also processed for contract offers, orders, or
      other inquiries.
    </p>
    <h5>What rights do you have regarding your data?</h5>
    <p>
      You have the right to request, at any time and free of charge, information about the origin, recipients, and purpose of your stored
      personal data. You also have the right to request the correction or deletion of this data. If you have given consent for data
      processing, you can revoke this consent at any time for the future. Additionally, you have the right to request the restriction of
      processing your personal data under certain circumstances. You also have the right to file a complaint with the responsible supervisory
      authority.
    </p>
    <p>You can contact us at any time with any questions regarding data protection.</p>

    <h5>2. Hosting</h5>
    <p>We host the content of our website with the following provider:</p>
    <h5>Squarespace</h5>
    <p>
      The provider is Squarespace Ireland Ltd., Le Pole House, Ship Street Great, Dublin 8, Ireland (hereinafter referred to as Squarespace).
    </p>
    <p>
      Squarespace is a tool for creating and hosting websites. When you visit our website, your data is processed on Squarespace's servers.
      Personal data may also be transmitted to Squarespace's parent company, Squarespace Inc., 8 Clarkson St, New York, NY 10014, USA.
      Squarespace also stores cookies that are necessary for displaying the site and ensuring security (necessary cookies).
    </p>
    <p>
      The use of Squarespace is based on Article 6, paragraph 1, letter f of the GDPR. We have a legitimate interest in providing our website
      as reliably as possible. If consent has been requested, the processing is carried out exclusively on the basis of Article 6, paragraph
      1, letter a of the GDPR and Section 25, paragraph 1 of the TTDSG, insofar as consent includes the storage of cookies or access to
      information on the user's end device (e.g., device fingerprinting) as defined by the TTDSG. Consent can be revoked at any time.
    </p>
    <p>
      Data transmission to the USA is based on the EU Commission's standard contractual clauses. For details, please visit:
      <a href="https://support.squarespace.com/hc/de/articles/360000851908-DSGVO-und-Squarespace" target="_blank" rel="noopener noreferrer"
      >https://support.squarespace.com/hc/de/articles/360000851908-DSGVO-und-Squarespace</a
      >.
    </p>
    <p>
      The company is certified under the "EU-US Data Privacy Framework" (DPF). The DPF is an agreement between the European Union and the USA
      that ensures compliance with European data protection standards in data processing in the USA. Any company certified under the DPF
      commits to complying with these data protection standards. For more information, you can visit the provider's page at the following
      link:
      <a href="https://www.dataprivacyframework.gov/participant/4774" target="_blank" rel="noopener noreferrer"
      >https://www.dataprivacyframework.gov/participant/4774</a
      >.
    </p>
    <h5>3. General Information and Mandatory Information</h5>
    <h5>Data Protection</h5>
    <p>
      The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in
      accordance with the legal data protection regulations and this privacy policy.
    </p>
    <p>
      When you use this website, various personal data is collected. Personal data is data that can be used to personally identify you. This
      privacy policy explains what data we collect and how we use it. It also explains how and for what purpose this happens.
    </p>
    <p>
      Please note that data transmission on the internet (e.g., when communicating via email) may have security vulnerabilities. Complete
      protection of data from third-party access is not possible.
    </p>
    <h5>Note on the Responsible Party</h5>
    <p>The responsible party for data processing on this website is:</p>
    <p>
      Philip Spahn<br />
      Alt-Heddernheim 43<br />
      60439 Frankfurt am Main
    </p>

    <p>
      Phone: [Phone number of the responsible party]<br />
      Email: [Email address of the responsible party]
    </p>
    <p>
      The responsible party is the natural or legal person who, alone or together with others, determines the purposes and means of processing
      personal data (e.g., names, email addresses, etc.).
    </p>

    <h5>Retention Period</h5>
    <p>
      If no specific retention period is mentioned within this privacy policy, your personal data will remain with us until the purpose for
      processing the data is no longer applicable. If you request the deletion of your data or revoke your consent to data processing, your
      data will be deleted unless we have other legally permissible grounds for storing your personal data (e.g., tax or commercial retention
      periods); in the latter case, the deletion will take place after the expiration of these grounds.
    </p>
    <h5>General Notes on the Legal Basis of Data Processing on This Website</h5>
    <p>
      If you have consented to data processing, we process your personal data based on Article 6, paragraph 1, letter a of the GDPR or Article
      9, paragraph 2, letter a of the GDPR, if special categories of data are processed according to Article 9, paragraph 1 of the GDPR. In
      the case of explicit consent for the transfer of personal data to third countries, data processing also takes place based on Article 49,
      paragraph 1, letter a of the GDPR. If you have consented to the storage of cookies or access to information on your end device (e.g.,
      via device fingerprinting), data processing also occurs based on Section 25, paragraph 1 of the TTDSG. The consent can be revoked at any
      time. If your data is necessary for contract performance or for carrying out pre-contractual measures, we process your data based on
      Article 6, paragraph 1, letter b of the GDPR. Furthermore, we process your data if it is necessary to fulfill a legal obligation based
      on Article 6, paragraph 1, letter c of the GDPR. Data processing may also occur based on our legitimate interest according to Article 6,
      paragraph 1, letter f of the GDPR. The relevant legal grounds for each case will be explained in the following sections of this privacy
      policy.
    </p>
    <h5>Recipients of Personal Data</h5>
    <p>
      As part of our business activities, we collaborate with various external parties. In some cases, it is necessary to transmit personal
      data to these external parties. We only pass on personal data to external parties when this is necessary for contract fulfillment, when
      we are legally obligated to do so (e.g., data transmission to tax authorities), when we have a legitimate interest in the transmission
      under Article 6, paragraph 1, letter f of the GDPR, or when another legal basis permits the data transfer. When using data processors,
      we transmit personal data to our customers only based on a valid contract for processing. In the case of joint processing, a contract
      for joint processing is concluded.
    </p>
    <h5>Revocation of Your Consent to Data Processing</h5>
    <p>
      Many data processing operations are only possible with your express consent. You can revoke any consent you have already given at any
      time. The legality of the data processing carried out until the revocation remains unaffected by the revocation.
    </p>
    <h5>Right to Object to Data Collection in Special Cases and Against Direct Marketing (Art. 21 GDPR)</h5>
    <p>
      IF DATA PROCESSING IS BASED ON ARTICLE 6, PARAGRAPH 1, LETTER E OR F OF THE GDPR, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME, FOR REASONS
      ARISING FROM YOUR PARTICULAR SITUATION, TO THE PROCESSING OF YOUR PERSONAL DATA; THIS ALSO APPLIES TO PROFILING BASED ON THESE
      PROVISIONS. THE RELEVANT LEGAL BASIS FOR PROCESSING CAN BE FOUND IN THIS PRIVACY POLICY. IF YOU OBJECT, WE WILL NO LONGER PROCESS YOUR
      PERSONAL DATA, UNLESS WE CAN DEMONSTRATE COMPELLING LEGITIMATE GROUNDS FOR PROCESSING THAT OVERRIDE YOUR INTERESTS, RIGHTS AND FREEDOMS,
      OR THE PROCESSING IS NECESSARY FOR THE ESTABLISHMENT, EXERCISE OR DEFENSE OF LEGAL CLAIMS (OBJECTION UNDER ARTICLE 21, PARAGRAPH 1 OF
      THE GDPR).
    </p>
    <p>
      IF YOUR PERSONAL DATA IS PROCESSED FOR THE PURPOSE OF DIRECT MARKETING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF
      YOUR PERSONAL DATA FOR SUCH MARKETING PURPOSES; THIS ALSO APPLIES TO PROFILING, INSOFAR AS IT IS RELATED TO SUCH DIRECT MARKETING. IF
      YOU OBJECT, YOUR PERSONAL DATA WILL NO LONGER BE USED FOR DIRECT MARKETING PURPOSES (OBJECTION UNDER ARTICLE 21, PARAGRAPH 2 OF THE
      GDPR).
    </p>
    <h5>Right to Lodge a Complaint with the Competent Supervisory Authority</h5>
    <p>
      In the event of violations of the GDPR, data subjects have the right to lodge a complaint with a supervisory authority, particularly in
      the member state of their habitual residence, their place of work, or the location of the alleged infringement. The right to complain
      exists without prejudice to any other administrative or judicial remedy.
    </p>
    <h5>Right to Data Portability</h5>
    <p>
      You have the right to request that data we process based on your consent or in fulfillment of a contract be handed over to you or to a
      third party in a common, machine-readable format. If you request the direct transfer of data to another responsible party, this will
      only take place if it is technically feasible.
    </p>
    <h5>Access, Correction, and Deletion</h5>
    <p>
      You have the right, in accordance with applicable law, to request free access to your stored personal data at any time, including its
      origin, recipients, and the purpose of data processing, and, if applicable, the right to correct or delete this data. You can contact us
      at any time regarding these rights or any further questions about personal data.
    </p>
    <h5>Right to Restriction of Processing</h5>
    <p>
      You have the right to request the restriction of the processing of your personal data. You can contact us at any time for this. The
      right to restrict processing exists in the following cases:
    </p>
    <ul>
      <li>
        If you dispute the accuracy of the personal data we store, we usually need time to verify this. For the duration of the verification,
        you have the right to request the restriction of the processing of your personal data.
      </li>
      <li>
        If the processing of your personal data was unlawful, you can instead request the restriction of processing rather than the deletion.
      </li>
      <li>
        If we no longer need your personal data, but you need it to assert, exercise, or defend legal claims, you have the right to request
        the restriction of the processing of your personal data instead of deletion.
      </li>
      <li>
        If you have objected under Article 21, paragraph 1 of the GDPR, a balance must be struck between your and our interests. Until it is
        determined whose interests outweigh, you have the right to request the restriction of processing of your personal data.
      </li>
    </ul>
    <p>
      If you have restricted the processing of your personal data, these data – apart from storage – may only be processed with your consent
      or to establish, exercise, or defend legal claims, or for the protection of the rights of another natural or legal person, or for
      reasons of important public interest of the European Union or a member state.
    </p>
    <h5>4. Data Collection on This Website</h5>
    <h5>Inquiries via Email, Phone, or Fax</h5>
    <p>
      If you contact us via email, phone, or fax, your inquiry, including all personal data derived from it (name, inquiry), will be stored
      and processed for the purpose of handling your request. We will not share this data without your consent.
    </p>
    <p>
      The processing of this data is based on Article 6, paragraph 1, letter b of the GDPR, if your inquiry is related to the fulfillment of a
      contract or necessary for carrying out pre-contractual measures. In all other cases, the processing is based on our legitimate interest
      in effectively handling the inquiries sent to us (Article 6, paragraph 1, letter f of the GDPR) or on your consent (Article 6, paragraph
      1, letter a of the GDPR) if this has been requested; consent can be revoked at any time.
    </p>
    <p>
      The data you send us via contact inquiries will remain with us until you request its deletion, revoke your consent to storage, or the
      purpose for storing the data no longer applies (e.g., after the completion of processing your request). Mandatory legal provisions –
      particularly legal retention periods – remain unaffected.
    </p>
    <h5>5. Plugins and Tools</h5>
    <h5>Google Fonts</h5>
    <p>
      This site uses Google Fonts to ensure consistent font display, which are provided by Google. When you visit a page, your browser loads
      the necessary fonts into its browser cache to display text and fonts correctly.
    </p>
    <p>
      For this purpose, the browser you use must establish a connection to Google’s servers. This allows Google to know that this website was
      accessed via your IP address. The use of Google Fonts is based on Article 6, paragraph 1, letter f of the GDPR. The website operator has
      a legitimate interest in the consistent presentation of the text on their website. If consent has been requested, processing will take
      place exclusively based on Article 6, paragraph 1, letter a of the GDPR and Section 25, paragraph 1 of the TTDSG, as far as consent
      includes the storage of cookies or access to information on the user’s end device (e.g., device fingerprinting) as defined by the TTDSG.
      Consent can be revoked at any time.
    </p>
    <p>If your browser does not support Google Fonts, a default font from your computer will be used.</p>
    <p>
      For more information on Google Fonts, please visit
      <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">https://developers.google.com/fonts/faq</a>
      and Google's privacy policy at
      <a href="https://policies.google.com/privacy?hl=en" target="_blank" rel="noopener noreferrer"
      >https://policies.google.com/privacy?hl=en</a
      >.
    </p>

    <h5>Storage of Customer Data at Stripe and Firebase</h5>
    <p>
      If you make a payment via Stripe on our website, we will store your name and email address. This data will be stored in our Firebase
      database to manage your order and communicate with you. Other data, such as your billing address, will only be processed by Stripe and
      not stored by us.
    </p>
    <p>
      For more information on the data protection processing by Stripe, you can refer to their privacy policy at:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <h5>6. Data Collection on This Website</h5>

    <h5>Encrypted Payment Transactions on the Website</h5>

    <p>
      <strong>Payment Data</strong><br />
      For payment processing on our website, we use the payment service provider Stripe. All payments are processed via an encrypted
      connection (SSL/TLS) to protect your sensitive payment information. The payment data you enter is processed only for the purpose of
      payment processing and in accordance with Stripe's privacy policy.
    </p>

    <p>
      For more information on data protection processing by Stripe, refer to their privacy policy at:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <h5>Communication via WhatsApp</h5>

    <p>
      <strong>Use of WhatsApp</strong><br />
      We offer you the possibility to communicate with us via WhatsApp. If you use this communication method, the data you transmit (e.g.,
      phone number, name, messages) will be processed by WhatsApp. We store this data only to contact you and process your request. WhatsApp
      processes data in accordance with its own privacy policy, which you can view here:
      <a href="https://www.whatsapp.com/legal" target="_blank" rel="noopener noreferrer">WhatsApp Privacy Policy</a>.
    </p>

    <p>The use of WhatsApp is based on your consent (Article 6, paragraph 1, letter a of the GDPR), which you can revoke at any time.</p>

    <h5>Communication via Telegram</h5>

    <p>
      <strong>Use of Telegram</strong><br />
      We also offer you the option to communicate with us via Telegram. If you use this communication method, the data you transmit (e.g.,
      phone number, name, messages) will be processed by Telegram. We store this data only to contact you and process your request. Telegram
      processes data according to its own privacy policy, which you can view here:
      <a href="https://telegram.org/privacy" target="_blank" rel="noopener noreferrer">Telegram Privacy Policy</a>.
    </p>

    <p>The use of Telegram is based on your consent (Article 6, paragraph 1, letter a of the GDPR), which you can revoke at any time.</p>

    <h5>Payment Services – Use of Stripe</h5>

    <p>
      <strong>Payment Processing with Stripe</strong><br />
      To process payments on our website, we use the payment service provider Stripe. Stripe processes personal data required for payment
      processing, such as payment data, billing address, and other relevant information. Stripe collects, stores, and processes this data in
      accordance with its own privacy policy, which you can view here:
      <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">Stripe Privacy Policy</a>.
    </p>

    <p>
      The use of Stripe is based on Article 6, paragraph 1, letter b of the GDPR to process payments within the framework of our contractual
      services. Data transmission occurs only as necessary for payment processing.
    </p>

    <p>
      The company is certified under the "EU-US Data Privacy Framework" (DPF). The DPF is an agreement between the European Union and the USA,
      designed to ensure compliance with European data protection standards in data processing in the USA. Any company certified under the DPF
      commits to adhering to these data protection standards. For more information, you can visit the provider’s page at the following link:
      <a href="https://www.dataprivacyframework.gov/participant/5780" target="_blank" rel="noopener noreferrer"
      >https://www.dataprivacyframework.gov/participant/5780</a
      >.
    </p>

    <div class="row justify-center">
      <q-btn
          no-caps
          flat
          size="lg"
          color="primary"
          label="Zrück"
          icon="arrow_back_ios"
          @click="router.back()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

</script>

